import { ActionContextBasic } from '../index'
import { PageMsgInterface } from '@/interfaces/page'

export interface PageState {
  [key: string]: string;
  CaseList: string;
  CaseList2 : string;
  CreateCaseList2:string;
  QuotesList: string;
  PoliciesList: string;
  AccountsList: string;
  ContactList: string;
  AccountsListWithSearchval: string;
  AccountAllList: string;
  CaseListWithSearchval: string;
  PoliciesListWithSearchval: string;
  QuotesListWithSearchval: string;
  ContactAllList: string;
  ContactListWithSearchval: string;
  CaseRelatedQuotesList: string;
  CaseRelatedPoliciesList: string;
}

const state = () => ({
  CaseList: '',
  CaseList2: '',
  CreateCaseList2: '',
  QuotesList: '',
  PoliciesList: '',
  AccountsList: '',
  ContactList: '',
  AccountsListWithSearchval: '',
  AccountAllList: '',
  CaseListWithSearchval: '',
  PoliciesListWithSearchval: '',
  QuotesListWithSearchval: '',
  ContactAllList: '',
  ContactListWithSearchval: '',
  CaseRelatedQuotesList: '',
  CaseRelatedPoliciesList: ''
})

const mutations = {
  STORE_PAGE (state: PageState, msg: PageMsgInterface) {
    const { page, options, filter } = msg
    state[page] = JSON.stringify({
      options,
      filter
    })
  },
  CLEAR_PAGE (state: PageState, routeName: string) {
    state[routeName] = ''
  }
}

const actions = {
  storePage: (context: ActionContextBasic, msg: PageMsgInterface) => {
    context.commit('STORE_PAGE', msg)
  },
  clearPage: (context: ActionContextBasic, routeName: string) => {
    context.commit('CLEAR_PAGE', routeName)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
